import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
import { trackMetaEvent } from '../../utils/metaPixel';
export function FinalCTA() {
  return <section className="bg-navy py-12 sm:py-16" data-id="element-49" data-mp="3mu1p5wwgqm83">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-50" data-mp="3mt8rdlfhf723">
        <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-51" data-mp="3rs390k1pqpkm">
          No esperes al próximo semestre.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-52" data-mp="3hup5fl0w1v9q">
          Mañana ya puedes usar la primera clase lista.
        </p>
        <p className="mt-2 font-semibold text-orange" data-id="element-53" data-mp="33w7me0lxh6y5">19€. Acceso de por vida. Garantía 7 días.</p>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-8 flex justify-center" data-id="element-54" data-mp="38usbp4zn667t">
          <PrimaryButton size="lg" onClick={() => trackMetaEvent('InitiateCheckout', {
          value: 19,
          currency: 'EUR'
        })} data-id="element-55" data-mp="170jiljbmoo0i">
            Acceso Ahora — 19€
          </PrimaryButton>
        </m.div>

        <p className="mt-4 text-xs text-white/60" data-id="element-56" data-mp="z0p6cgyvyg75">Dinero de vuelta si no funciona. Sin preguntas.</p>
      </div>
    </section>;
}